import { render, staticRenderFns } from "./add-company.vue?vue&type=template&id=2a2e9cee"
import script from "./add-company.vue?vue&type=script&lang=js"
export * from "./add-company.vue?vue&type=script&lang=js"
import style0 from "./add-company.vue?vue&type=style&index=0&id=2a2e9cee&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2e9cee')) {
      api.createRecord('2a2e9cee', component.options)
    } else {
      api.reload('2a2e9cee', component.options)
    }
    module.hot.accept("./add-company.vue?vue&type=template&id=2a2e9cee", function () {
      api.rerender('2a2e9cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/add-company.vue"
export default component.exports